const Calendar2Icon = ({ width, height, color, style }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? 30}
            height={height ?? 30}
            viewBox="0 0 512 512"
            style={style}
        >
            <rect
                width="416"
                height="384"
                x="48"
                y="80"
                fill="none"
                stroke={color ?? '#ffffff'}
                strokeLinejoin="round"
                strokeWidth="32"
                rx="48"
            />
            <path
                fill="none"
                stroke={color ?? '#ffffff'}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="32"
                d="M128 48v32m256-32v32m80 80H48m256 100l43.42-32H352v168m-160.13-89.37c9.11 0 25.79-4.28 36.72-15.47a37.9 37.9 0 0 0 11.13-27.26c0-26.12-22.59-39.9-47.89-39.9c-21.4 0-33.52 11.61-37.85 18.93M149 374.16c4.88 8.27 19.71 25.84 43.88 25.84c28.59 0 52.12-15.94 52.12-43.82c0-12.62-3.66-24-11.58-32.07c-12.36-12.64-31.25-17.48-41.55-17.48"
            />
        </svg>
    );
};

export default Calendar2Icon;
